const MemberPrimaryAttributes = {
    EMAIL: "EMAIL",
    MOBILE_NUMBER: "MOBILE_NUMBER",
};

const MemberPrimaryAttributesAsObjAttributes = {
    [MemberPrimaryAttributes.EMAIL]: "email",
    [MemberPrimaryAttributes.MOBILE_NUMBER]: "mobileNumber",
};

const MemberPrimaryAttributeObjectPropertyName = {
    [MemberPrimaryAttributes.EMAIL]: "email",
    [MemberPrimaryAttributes.MOBILE_NUMBER]: "mobile number",
};

export {
    MemberPrimaryAttributes,
    MemberPrimaryAttributesAsObjAttributes,
    MemberPrimaryAttributeObjectPropertyName,
};
